import { APP_PROXY_URL, API_BASE_URL } from '../utils/constants';
import {
  handleCartApiError,
  ErrorApiObject,
  ExceptionErrorApiObject,
} from './bundleUtils';

export const updateCart = async (
  bodyItem: BundleCartBodyItem,
  bodyAddons: BundleCartBodyAddon[],
  individualProductsCollection: LiquidProductInCollection[],
  productsInAddonsCollection: LiquidProductInCollection[],
): Promise<unknown> => {
  const body: BundleCartBody = {
    items: [bodyItem, ...bodyAddons],
  };

  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  const json = await response.json();
  if (!response.ok) {
    const error: string | ErrorApiObject = handleCartApiError(
      json,
      individualProductsCollection,
      productsInAddonsCollection,
    );

    if (typeof error === 'string') {
      throw new Error(error);
    } else {
      throw new ExceptionErrorApiObject(error as ErrorApiObject);
    }
  }

  return json;
};
export const updateCartWithItems = async (
  bodyItems: ProductWithProps[],
  bodyAddons: BundleCartBodyAddon[],
  individualProductsCollection: LiquidProductInCollection[],
  productsInAddonsCollection: LiquidProductInCollection[],
): Promise<unknown> => {
  const body: BundleCartBody = {
    items: [...bodyItems, ...bodyAddons],
  };

  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  const json = await response.json();

  if (!response.ok) {
    const error: string | ErrorApiObject = handleCartApiError(
      json,
      individualProductsCollection,
      productsInAddonsCollection,
    );

    if (typeof error === 'string') {
      throw new Error(error);
    } else {
      throw new ExceptionErrorApiObject(error as ErrorApiObject);
      await cleanBundleFromCart([...bodyItems, ...bodyAddons]);
    }
  }

  return json;
};

const cleanBundleFromCart = async (
  bodyItems: (BundleCartBodyItem | BundleCartBodyAddon)[],
): Promise<unknown> => {
  const body: BundleCartBody = {
    items: bodyItems.map((item) => ({
      id: item.id,
      quantity: 0,
    })),
  };

  const response = await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  const json = await response.json();

  if (!response.ok) {
    throw new Error('Error cleaning bundle from cart');
  }

  return json;
};

export const getCart = async (): Promise<Cart> => {
  const response = await fetch('/cart.js');

  if (!response.ok) {
    throw new Error('Error getting cart');
  }

  const json = await response.json();

  return json;
};

export const getBaBSingleProducts = async (
  products: string,
): Promise<LiquidProductInCollection[]> => {
  const url = `${APP_PROXY_URL}/api/products?includeReviews=1&productsHandles=${products}`;

  const response = await fetch(url, {
    headers: { 'Content-Type': 'text/plain' },
  });

  if (!response.ok) {
    throw new Error('Error getting bundle products');
  }

  const json = await response.json();

  return json?.products;
};

// This request is being made to awtomic-api
export const getBundleDiscounts = async ({
  bundleId,
  variantId,
  shopDomain,
}): Promise<BundleSetting> => {
  const url = `${API_BASE_URL}/bundles/${bundleId}/variants/${variantId}/discounts`;

  const response = await fetch(url, {
    headers: { 'x-shop-domain': shopDomain },
  });

  if (!response.ok) {
    throw new Error('Error getting bundle discounts');
  }

  const json = await response.json();

  return json;
};

export const getThemeApplicationData = async ({
  themeApplicationId,
  shopDomain,
}) => {
  const url = `${API_BASE_URL}/themes/applications/${themeApplicationId}`;
  try {
    const response = await fetch(url, {
      headers: { 'x-shop-domain': shopDomain },
    });

    if (!response.ok) {
      throw new Error('Error getting theme application data');
    }

    const json = await response.json();

    return json;
  } catch (error) {
    console.error('Error getting default theme application:', error);
    throw error;
  }
};
